import { create } from 'zustand';

const useStore = create((set) => ({
  isModal: false,
  setIsModal: () => set((state) => ({ isModal: !state.isModal })),
}));

export default useStore;
